__turbopack_context__.v({
  "modalContent": "FolderCreationModal-module__n9abWa__modalContent",
  "sharedCheckbox": "FolderCreationModal-module__n9abWa__sharedCheckbox",
});
